import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: 'Does BBL hurt?',
    a: 'Most patients describe the sensation as a quick, warm snap against the skin. We use advanced cooling technology during the treatment to ensure your comfort. No numbing cream is typically required.'
  }, {
    q: 'How is BBL different from IPL?',
    a: 'BBL (BroadBand Light) is the next generation of IPL. It uses dual-lamp technology and smart cooling for more precise, powerful, and comfortable treatments. BBL is also the only light therapy clinically proven to change the expression of aging genes.'
  }, {
    q: 'How many treatments will I need?',
    a: 'While you will see significant improvement after just one session, we typically recommend an initial series of 2-3 treatments for optimal correction, followed by 1-2 maintenance treatments per year to keep your skin in a continuous state of renewal.'
  }, {
    q: 'Can BBL treat redness and rosacea as well as brown spots?',
    a: 'Yes. BBL is highly customizable. We can change the filters during your session to target both melanin (brown spots/sun damage) and hemoglobin (redness/broken capillaries) in the same visit.'
  }, {
    q: "What's the downtime?",
    a: 'There is zero clinical downtime. You can apply makeup and return to work immediately. Over the next 3-5 days, targeted brown spots will darken (resembling coffee grounds) and naturally flake off, revealing fresh, even skin underneath.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-32 bg-brand-alt" id="faq" data-id="element-90">
      <div className="container px-4 md:px-6 max-w-3xl" data-id="element-91">
        <div className="text-center mb-12 md:mb-16" data-id="element-92">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-brand-text" data-id="element-93">
            Common Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-94">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-brand-divider pb-4" data-id="element-95">
                <button className="w-full flex items-center justify-between py-4 text-left focus:outline-none group" onClick={() => toggleFAQ(index)} aria-expanded={isOpen} data-id="element-96">
                  <span className="font-playfair text-lg md:text-xl text-brand-text group-hover:text-brand-gold transition-colors pr-8" data-id="element-97">
                    {faq.q}
                  </span>
                  <span className="text-brand-gold flex-shrink-0" data-id="element-98">
                    {isOpen ? <MinusIcon className="w-5 h-5" data-id="element-99" /> : <PlusIcon className="w-5 h-5" data-id="element-100" />}
                  </span>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 mb-4' : 'max-h-0 opacity-0'}`} data-id="element-101">
                  <p className="font-sans text-brand-text/70 leading-relaxed pr-8" data-id="element-102">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}